import React from 'react';
import PropTypes from 'prop-types';
import __map from 'lodash/map';

import './DropdownWrapper.css';

class Dropdown extends React.Component {
  render() {
    const { name, selectedValue, onChange, options, specialKeys, extraClass } = this.props;
    return (
      <div className={ `dropdown-wrapper ${ extraClass }` }>
        <select name={ name } value={ selectedValue } onChange={ onChange }>
        {
          options !== undefined &&
          __map(options, function(option, i) {
            if (specialKeys) {
              return <option key={ i } value={ option[specialKeys[1]] }>{ option[specialKeys[0]] }</option>
            }
            return <option key={ i } value={ option.value }>{ option.text }</option>
          })
        }
        </select>
      </div>
    );
  }
}

Dropdown.propTypes = {
    name: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    selectedValue: PropTypes.string,
    extraClass: PropTypes.string,
    specialKeys: PropTypes.array //some data will not be created in-house
}

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/elements/Dropdown/index.js